import { motion } from "framer-motion";
import { CHAPTERS } from "@/data/catalog";
import ProductCard from "@/components/shop/ProductCard";

const Catalog = () => (
  <section id="catalogo" data-testid="catalog-section" className="relative px-6 py-32 md:px-12">
    <div className="mx-auto max-w-7xl">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="mb-24 font-mono text-xs uppercase tracking-[0.25em] text-[#cba153]"
      >
        Catalogo prezzi — aggiornato a Luglio 2026
      </motion.p>

      {CHAPTERS.map((chapter) => (
        <div key={chapter.id} className="relative mb-32 last:mb-0">
          <span
            aria-hidden
            className="pointer-events-none absolute -top-16 left-0 select-none font-display text-[18vw] leading-none text-white/5 md:text-[12vw]"
          >
            {chapter.number}
          </span>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative mb-16 pt-16"
          >
            <h2 className="font-display text-4xl tracking-tighter text-[#fafafa] md:text-5xl">
              {chapter.title}
            </h2>
            <p className="mt-3 max-w-md text-base font-light text-[#888]">
              {chapter.subtitle}
            </p>
          </motion.div>

          <div className="relative grid grid-cols-2 gap-8 md:grid-cols-4 md:gap-12">
            {chapter.products.map((product, i) => (
              <ProductCard key={product.id} product={product} index={i} />
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Catalog;
